package com.wintermar.inspection.di

import com.apollographql.apollo.ApolloClient
import com.apollographql.apollo.network.NetworkTransport
import com.apollographql.apollo.network.http.HttpNetworkTransport
import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import com.wintermar.inspection.EnvConfig
import com.wintermar.inspection.core.data.TokenInterceptor
import com.wintermar.inspection.core.ui.component.connectivity_monitor.util.ConnectivityMonitor
import com.wintermar.inspection.feature.data.local.db.DriverFactory
import kotlinx.browser.window
import org.koin.core.module.Module
import org.koin.dsl.module

actual val platformModule: Module = module {
    single<org.w3c.dom.Storage> {
        window.localStorage
    }

    single<Settings> {
        StorageSettings(delegate = get())
    }

    single<NetworkTransport> {
        HttpNetworkTransport.Builder()
            .addInterceptor(get<TokenInterceptor>())
            .serverUrl(EnvConfig.API_URL)
            .build()
    }

    single<ApolloClient> {
        ApolloClient.Builder()
            .networkTransport(
                get()
            )
            .build()
    }

    single<DriverFactory> {
        DriverFactory()
    }

    single<ConnectivityMonitor> {
        ConnectivityMonitor()
    }
}
